import React from "react";
import classnames from "classnames";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import styles from "./email-live-chat.module.scss";
import LiveChatButton from "../../live-chat-button/LiveChatButton";

function EmailLiveChat({ questionId, liveChat, onEmailClick = () => {} }) {
  const buttonLocation = "email_us | email_us";

  return (
    <div className={styles["email-form-node__live-chat-question"]}>
      <label htmlFor={questionId}>{liveChat.question}</label>
      <p>{liveChat.subtitle}</p>
      <div className={styles["email-form-node__live-chat-question__btn-wrapper"]}>
        <div>
          <SecondaryButton onClick={onEmailClick}>{liveChat.buttons.email}</SecondaryButton>
        </div>
        <div>
          <LiveChatButton
            channel={liveChat.channel}
            className={classnames(
              "c-button c-button--secondary",
              styles["email-form-node__live-chat-question__btn-chat"],
            )}
            buttonLocation={buttonLocation}
          />
        </div>
      </div>
    </div>
  );
}

export default EmailLiveChat;
